import React from 'react';

import {
  Route,
  HashRouter,
} from 'react-router-dom';

import HomePage from './containers/HomePage';
import QuotaHistoryTableSorting from './containers/QuotaHistoryTableSorting';
import PortfolioCompositionTableSorting from './containers/PortfolioCompositionTableSorting';
import Profitability from './containers/Profitability';

export default () => (
  <HashRouter basename="/">
    <Route exact path="/" component={HomePage} />
    <Route path="/quota-history-table-sorting/:ticker" component={QuotaHistoryTableSorting} />
    <Route path="/portfolio-composition-table-sorting/:ticker" component={PortfolioCompositionTableSorting} />
    <Route path="/profitability/:ticker" component={Profitability} />
  </HashRouter>
);
